import { getBridgeToNative } from '@alfa-bank/newclick-core/window-utils';
export const useWebview = () => {
    const bridgeToNative = getBridgeToNative();
    const isWebview = !!bridgeToNative;
    const themeWebview = bridgeToNative?.theme;
    return {
        isWebview,
        bridgeToNative,
        themeWebview,
    };
};
